<script setup lang="ts">
import { useCdnImages } from '../../../composables/use-cdn-images'

const { cdnImageUrl } = useCdnImages()
</script>

<template>
  <div>
    <a class="bx-header__logo bx-header__logo--autozeitung"
       title="https://www.autozeitung.de/"
       href="/">
      <img :src="cdnImageUrl('/images/autozeitung/autozeitung-logo.svg')"
           alt="AUTO ZEITUNG Logo"
           width="247"
           height="120">
    </a>
  </div>
</template>
